<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBDocumentForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBDocumentList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBDocumentForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXSBDocumentForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbdocument/update/isLoading',
      error: 'exsbdocument/update/error',
      deleteError: 'exsbdocument/del/error',
      deleteLoading: 'exsbdocument/del/isLoading',
      created: 'exsbdocument/create/created',
      deleted: 'exsbdocument/del/deleted',
      retrieved: 'exsbdocument/update/retrieved',
      updated: 'exsbdocument/update/updated',
      violations: 'exsbdocument/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBDocumentList' })
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBDocumentUpdate')
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbdocument/create/reset',
      deleteItem: 'exsbdocument/del/del',
      delReset: 'exsbdocument/del/reset',
      retrieve: 'exsbdocument/update/retrieve',
      updateReset: 'exsbdocument/update/reset',
      update: 'exsbdocument/update/update',
      updateRetrieved: 'exsbdocument/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbdocument ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
